import { Check, ChevronsUpDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

const OPTIONS = [25, 50, 100];

// Premium "rows per page" selector used across paginated screens.
export default function PageSizeSelector({ value, onChange, testid = "page-size" }) {
  return (
    <div className="flex items-center gap-2 text-sm text-ink/55" data-testid={testid}>
      <span className="hidden sm:inline">Rows</span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            data-testid={`${testid}-trigger`}
            className="flex items-center gap-1.5 rounded-lg border border-sky bg-white px-2.5 py-1.5 font-semibold text-navy transition-colors hover:bg-mist focus:outline-none focus:ring-2 focus:ring-loop/25"
          >
            {value}
            <ChevronsUpDown className="h-3.5 w-3.5 text-ink/40" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[5.5rem]">
          {OPTIONS.map((o) => (
            <DropdownMenuItem
              key={o}
              data-testid={`${testid}-opt-${o}`}
              onClick={() => onChange(o)}
              className="flex items-center justify-between gap-3 font-medium"
            >
              {o}
              {o === value && <Check className="h-3.5 w-3.5 text-loop" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
